import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const LANGUAGE_STORAGE_KEY = "bhajanmala_language";
const DEFAULT_LANGUAGE = "English";

// Load language from localStorage or use default
const getInitialLanguage = (): string => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return stored || DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

interface LanguageState {
  selectedLanguage: string;
}

const initialState: LanguageState = {
  selectedLanguage: getInitialLanguage(),
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.selectedLanguage = action.payload;
      // Persist to localStorage
      try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, action.payload);
      } catch {
        // Ignore localStorage errors
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
